module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"headline":"Optimizuota (išmani) sistema","text":"Nogrid vieni pirmųjų Lietuvos rinkoje pradėjo prekiauti ir siūlyti optimizuotą (išmanią) įrangą. Ji yra iki 25% efektyvesnė ir saugesnė nei standartinės sistemos.","cta":"Gaukite pasiūlymą"}}')
  delete Component.options._Ctor
}
